import { Reference } from '@medplum/fhirtypes'

export enum ServicePlanAssessmentSections {
  ASSESSMENT_OVERVIEW = 'assessment-overview',
  PATIENT_OVERVIEW = 'patient-overview',
  AUTHORIZATION = 'authorization',
  SERVICE_PLAN = 'service-plan-tasks',
  VISIT_SCHEDULING = 'visit-scheduling',
  FINAL_STEPS = 'final-steps'
}

export const ServicePlanAssessmentAnchors = [
  {
    key: ServicePlanAssessmentSections.ASSESSMENT_OVERVIEW,
    href: '#assessment-overview',
    title: 'Assessment Overview'
  },
  {
    key: ServicePlanAssessmentSections.PATIENT_OVERVIEW,
    href: '#patient-overview',
    title: 'Patient Overview'
  },
  {
    key: ServicePlanAssessmentSections.AUTHORIZATION,
    href: '#authorization',
    title: 'Authorization'
  },
  {
    key: ServicePlanAssessmentSections.SERVICE_PLAN,
    href: '#service-plan-tasks',
    title: 'Service Plan'
  },
  {
    key: ServicePlanAssessmentSections.VISIT_SCHEDULING,
    href: '#visit-scheduling',
    title: 'Visit Scheduling'
  },
  {
    key: ServicePlanAssessmentSections.FINAL_STEPS,
    href: '#final-steps',
    title: 'Final Steps'
  }
]

export interface TaskInfo {
  id?: number
  adl?: string
  serviceType?: Reference
  directions?: string
  frequency?: string[]
}

export interface PatientTaskInfo {
  id: number
  adl: string
  directions?: string
}

// Add sections here as they are migrated from controlled to uncontrolled
export const UNCONTROLLED_FORM_SECTION: Set<ServicePlanAssessmentSections> = new Set([
  ServicePlanAssessmentSections.ASSESSMENT_OVERVIEW,
  ServicePlanAssessmentSections.PATIENT_OVERVIEW,
  ServicePlanAssessmentSections.AUTHORIZATION,
  ServicePlanAssessmentSections.SERVICE_PLAN,
  ServicePlanAssessmentSections.VISIT_SCHEDULING,
  ServicePlanAssessmentSections.FINAL_STEPS
])
